import React, { useState, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import "./index.css";
import parse from 'html-react-parser';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const GameOnQuotes = ({ gameOnQuotes }) => {
  // const [gameOnQuotes, setGameOnQuotes] = useState([]);
  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
  const sliderRef = useRef(null);
 

  // Handle play video
  const handlePlayVideo = (index) => {
    setPlayingVideoIndex(index);
    sliderRef.current.slickPause(); // Pause autoplay when video plays
  };

  // Handle stop video
  const handleStopVideo = () => {
    setPlayingVideoIndex(null);
    sliderRef.current.slickPlay(); // Resume autoplay when video stops
  };

  // Custom Arrow Components
  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className="nextArrow"
        onClick={onClick}
      >
        <img src="https://resources.swmc.com/swmc-images/HomeImages/RA.webp" alt="Next" style={{ width: '40px', height: '36px' }} />
      </div>
    );
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className="prevArrow"
        onClick={onClick}
      >
        <img src="https://resources.swmc.com/swmc-images/HomeImages/LA.webp" alt="Prev" style={{ width: '40px', height: '36px' }} />
      </div>
    );
  };

  // Carousel settings
  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    cssEase: 'ease-in-out',
    draggable: true,
    pauseOnHover: false,
    beforeChange: () => handleStopVideo(),
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    lazyLoad: false,
    responsive: [
      {
        breakpoint: 1024, // Desktop and larger screens
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Tablet and mobile screens
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="gameoncontainer" >
      <Row className="justify-content-center">
        {gameOnQuotes.length > 0 && (
          <Col lg={12} className="text-center">
            <Slider ref={sliderRef} {...settings}>
              {gameOnQuotes.map((item, i) => (
                <div key={i}>
                  <Row id="quotes-banner" className="justify-content-center mb-2">
                    <Col sm={12}>
                      <p className="textHeading">
                        <a
                          href={item.webPageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="textHeading"
                        >
                          {parse(item.heading)}
                        </a>
                      </p>
                    </Col>
                  </Row>
                  <span className="thumbnailimage">
                    {item.videoURL ? (
                      <>
                        {playingVideoIndex === i ? (
                          // Video iframe when video is playing
                          <iframe
                            src={`https://www.youtube.com/embed/${item.videoURL}?autoplay=1&controls=1&enablejsapi=1&mute=1`}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            title={`video-${i}`}
                            className="carouselimage"

                          ></iframe>
                        ) : (

                          <img
                            src={item.imgURL}
                            className="carouselimage"
                            onClick={() => handlePlayVideo(i)}
                            style={{
                              cursor: 'pointer',
                              transition: 'transform 1.5s ease-in-out',
                            }}
                            alt={item.heading}
                            loading="eager"
                            decoding="async"
                            fetchpriority="high"
                            width={"498px"}
                            height={"389px"}
                          />
                        )}
                      </>
                    ) : (
                      // Static image if no video
                      <a href={item.webPageURL} target="_blank" rel="noopener noreferrer">
                        <img
                          src={item.imgURL}
                          className="carouselimage"
                          style={{
                            transition: 'transform 1.5s ease-in-out',
                          }}
                          alt={item.heading}
                          loading="eager"
                          decoding="async"
                          fetchpriority="high"
                          width={"498px"}
                          height={"389px"}
                        />
                      </a>
                    )}
                  </span>
                  <div className="subHeading">{item.subHeading}</div>
                </div>
              ))}
            </Slider>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default GameOnQuotes;
